'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { generateRoomId } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [roomName, setRoomName] = useState('');

  const startMeeting = () => {
    const room = roomName.trim() || generateRoomId();
    router.push(`/rooms/${room}`);
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>CAPMA Meeting Room</h1>
          <h2 style={{ opacity: 0.7, fontSize: '1rem' }}>
            Private audio conferencing for members
          </h2>
        </div>
        <div className={styles.tabContainer}>
          <div className={styles.tabContent} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <input
              type="text"
              placeholder="Enter room name (or leave blank for random)"
              value={roomName}
              onChange={(ev) => setRoomName(ev.target.value)}
              style={{ padding: '0.75rem', fontSize: '1rem' }}
            />
            <button className="lk-button" onClick={startMeeting} style={{ marginTop: '0.5rem' }}>
              Join Meeting
            </button>
          </div>
        </div>
      </main>
      <footer data-lk-theme="default">
        CAPMA Private Members Association — Secure Communications
      </footer>
    </>
  );
}
